import { getDiscountBonusAmountFromAmount } from "@/utils/return-requests";
import { getFinancialDiscountChargesAmount } from "./get-financial-discount-charges-amount";
import { ReturnRequestDto } from "@babackapp/private-api-client/types";

export function getTotalDiscountToHandle(
  returnRequest: ReturnRequestDto,
  totalCustomerPaidPriceDiscount: number,
  opt: {
    withBonus?: boolean;
    withCharges?: boolean;
    chargeForRefund?: boolean;
    chargeForInitialShipping?: boolean;
    forceRefundInitialShipping?: boolean;
  },
) {
  if (totalCustomerPaidPriceDiscount === 0) {
    return 0;
  }

  if (opt?.withBonus) {
    totalCustomerPaidPriceDiscount += getDiscountBonusAmountFromAmount(
      returnRequest,
      totalCustomerPaidPriceDiscount,
    );
  }

  if (opt?.withCharges) {
    totalCustomerPaidPriceDiscount -= getFinancialDiscountChargesAmount(
      returnRequest,
      opt.chargeForRefund,
      opt.chargeForInitialShipping,
      opt.forceRefundInitialShipping,
    );
  }

  return Math.round(totalCustomerPaidPriceDiscount * 100) / 100;
}
